const filterParams = params => Object.keys(params)
  .filter(key => !!params[key])
  .reduce((r, key) => { r[key] = params[key]; return r; }, {});

const urlWithParams = (url, params) => {
  const paramString = new URLSearchParams(filterParams(params)).toString();
  if (!paramString.length) return url;
  return `${url}?${paramString}`;
};

export default urlWithParams;
